import { THomePageConfig } from '@vNext/models/PublicationConfig/HomePageConfig';
import { homeShortcuts } from '../common';

export const homePageConfig: THomePageConfig = {
    shortcuts: [
        homeShortcuts.getFAQ('https://annonsevalg.schibsted.no/faq'),
        homeShortcuts.getPaymentHistory(),
        homeShortcuts.getPrivacySettings(CONFIG.privacySettings),
        homeShortcuts.getSubscriptionTerms(CONFIG.subscriptionTerms),
    ],
};
